import React,  { useEffect, useState } from 'react';
import { setUrlCategoryType } from 'utils/appUtils';

import * as S from './styles';

const QuestionItem = ({ url, title, type, active }) => {
    const [articleType, setArticleType] = useState();

    useEffect(() => {
        setArticleType(setUrlCategoryType(type.toLowerCase()));
    }, []);

	return (
		<S.QuestionItemWrapper to={`/artigo/${articleType}/${url}`}>
            <S.QuestionItemText className={active && 'active'}>{title}</S.QuestionItemText>
        </S.QuestionItemWrapper>
	);
}

export default QuestionItem;